import { render, staticRenderFns } from "./MoveTeamPopup.vue?vue&type=template&id=8068b244&scoped=true&"
import script from "./MoveTeamPopup.vue?vue&type=script&lang=js&"
export * from "./MoveTeamPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8068b244",
  null
  
)

export default component.exports